import { ClientType } from '../apollo'
import { types } from '../types'

import {
  findManySettlementItem,
} from './settlement-gql'

export async function readSettlementItems (client: ClientType, where: types.SettlementItemWhereInput, take: number, cursor: number | undefined): Promise<types.SettlementItem[] | undefined> {
  try {
    const result = await client.query({
      query: findManySettlementItem,
      variables: {
        where,
        orderBy: [
          { id: 'asc' },
        ],
        take,
        cursor,
        skip: cursor ? 1 : 0,
      } as types.QueryFindManySettlementItemArgs,
    })
    return result.data.findManySettlementItem
  } catch (e) {
  }
}
